import { render } from "./HeaderItem.vue?vue&type=template&id=05b5117e"
import script from "./HeaderItem.vue?vue&type=script&lang=js"
export * from "./HeaderItem.vue?vue&type=script&lang=js"

import "./HeaderItem.vue?vue&type=style&index=0&id=05b5117e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__